import { render } from "./DoneIcon.svg?vue&type=template&id=5049f01a"
const script = {}
script.render = render

export default script